import { DocumentCode } from './types'

export const documentWarnings: DocumentCode[] = [
  'amlPolicy',
  'proofOfAddress',
  'registerOfDirectors',
  'shareholderCertificate',
  'shareholderStructureChart',
]
